export default [
  {
    name: 'Polaco',
    level: 'Nativo',
    percent: 100,
    flag: 'https://flagcdn.com/w40/pl.png',
  },
  {
    name: 'Inglés',
    level: 'C1',
    percent: 80,
    flag: 'https://flagcdn.com/w40/us.png',
    certs: [{ level: '', link: '/certs/english-b2.pdf' }],
  },
  // {
  //   name: 'Noruego',
  //   level: 'B1+',
  //   percent: 60,
  //   flag: 'https://flagcdn.com/w40/no.png',
  // },
  // {
  //   name: 'Islandés',
  //   level: 'B1',
  //   percent: 50,
  //   flag: 'https://flagcdn.com/w40/is.png',
  // },
  {
    name: 'Alemán',
    level: 'A2+',
    percent: 35,
    flag: 'https://flagcdn.com/w40/de.png',
  },
  {
    name: 'Japonés',
    level: 'A2',
    percent: 25,
    flag: 'https://flagcdn.com/w40/jp.png',
  },
  // {
  //   name: 'Croata',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/hr.png',
  // },
  // {
  //   name: 'Ruso',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/ru.png',
  // },
]
